import { Skeleton } from '@mui/material'
import { DOWNLOAD_API } from 'api/download-api'
import { useGetByTenantDocumentationAccountAndAccountIdSummaryQuery } from 'api/rtk-api'
import { format } from 'date-fns'
import { FormProvider, useForm } from 'react-hook-form'
import { useParams } from 'react-router-dom'

import {
  Card,
  DownloadLink,
  LabelValueRow,
  onDownloadLinkClick,
  SelectField
} from '@/components/core-v2'
import { TENANT } from '@/const'

import { TradeTemplate } from '../../templates/trade-template'

export const SORT_BY_OPTIONS = [
  { label: 'Most recent first', value: 'recent' },
  { label: 'Oldest first', value: 'oldest' }
]

export const ReportingTradeHistoryAndDocumentsPage = () => {
  const { tradeId } = useParams()

  const { data, isLoading } = useGetByTenantDocumentationAccountAndAccountIdSummaryQuery({
    tenant: TENANT,
    accountId: tradeId
  })

  const form = useForm({
    defaultValues: {
      sortBy: SORT_BY_OPTIONS[0].value
    }
  })

  if (isLoading)
    return (
      <TradeTemplate tabValue="history-documents">
        <Skeleton height="28px" width="220px" />
        <Card.Wrapper className="mt-4">
          <LabelValueRow isLoading />
          <LabelValueRow isLoading />
          <LabelValueRow isLoading />
          <LabelValueRow isLoading />
          <LabelValueRow isLoading />
        </Card.Wrapper>
      </TradeTemplate>
    )

  const sortByValue = form.watch('sortBy')

  const documents = data.filter(document => document.stage === 'Final')
  const documentsReversed = [...documents].reverse()
  const sortedDocuments = sortByValue === 'recent' ? documents : documentsReversed

  return (
    <FormProvider {...form}>
      <TradeTemplate tabValue="history-documents">
        <SelectField id="sortBy" label="Sort by:" options={SORT_BY_OPTIONS} />
        <Card.Wrapper className="mt-4">
          {sortedDocuments.map(doc => (
            <LabelValueRow
              key={doc.accountId}
              label={format(new Date(doc.timestamp), 'd MMMM yyyy')}
              value={
                <DownloadLink
                  key={doc.accountId}
                  onClick={() =>
                    onDownloadLinkClick({
                      url: DOWNLOAD_API.tradeConfirmationDocument(tradeId, doc.number)
                    })
                  }
                >
                  {doc.fileName}
                </DownloadLink>
              }
            />
          ))}
        </Card.Wrapper>
      </TradeTemplate>
    </FormProvider>
  )
}
